import { getAuthClient } from "@/modules/authorisation/authClient";
import { useAuthorisationStore } from "@/modules/authorisation/authorisationStore";

export default async function redirectToHomeIfAuthorised() {
  const authorisationStore = useAuthorisationStore();
  const authClient = await getAuthClient();
  const token = await authClient.getAccessToken();
  if (token) {
    if (
      authorisationStore.redirectToAfterLoginUrl === "/auth/login" ||
      authorisationStore.redirectToAfterLoginUrl === "/403"
    ) {
      authorisationStore.redirectToAfterLoginUrl = undefined;
    }

    return authorisationStore.getRedirectToAfterLoginUrl || { name: "dashboard" };
  }
  return undefined;
}
